const EVENT_POPUP_DISMISSED_AT_KEY = "parkgorkogo_event_popup_dismissed_at";
const LEGACY_DISMISSED_KEY = "parkgorkogo_event_popup_dismissed";
const LEGACY_SHOWN_AT_KEY = "parkgorkogo_event_popup_shown_at";
const COOLDOWN_MS = 24 * 60 * 60 * 1000;

const parseTimestamp = (value) => {
	const parsed = Number(value);

	return Number.isFinite(parsed) ? parsed : null;
};

const getDismissedAt = () => {
	if (typeof window === "undefined") {
		return null;
	}

	const dismissedAt = parseTimestamp(localStorage.getItem(EVENT_POPUP_DISMISSED_AT_KEY));

	if (dismissedAt !== null) {
		return dismissedAt;
	}

	if (localStorage.getItem(LEGACY_DISMISSED_KEY) === "true") {
		const now = Date.now();
		localStorage.setItem(EVENT_POPUP_DISMISSED_AT_KEY, String(now));
		localStorage.removeItem(LEGACY_DISMISSED_KEY);
		return now;
	}

	const shownAt = parseTimestamp(localStorage.getItem(LEGACY_SHOWN_AT_KEY));

	if (shownAt !== null) {
		localStorage.setItem(EVENT_POPUP_DISMISSED_AT_KEY, String(shownAt));
		localStorage.removeItem(LEGACY_SHOWN_AT_KEY);
		return shownAt;
	}

	return null;
};

export const canShowEventAnnouncement = () => {
	if (typeof window === "undefined") {
		return false;
	}

	const dismissedAt = getDismissedAt();

	if (dismissedAt === null) {
		return true;
	}

	return Date.now() - dismissedAt >= COOLDOWN_MS;
};

export const dismissEventAnnouncement = () => {
	if (typeof window === "undefined") {
		return;
	}

	localStorage.setItem(EVENT_POPUP_DISMISSED_AT_KEY, String(Date.now()));
	localStorage.removeItem(LEGACY_DISMISSED_KEY);
	localStorage.removeItem(LEGACY_SHOWN_AT_KEY);
};
